import React from "react";
import styled from "styled-components";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";

import { DataTypePicker } from "../../../CommonUI/DataTypePicker/DataTypePicker";
import { DeleteGrayIcon } from "../../../CommonUI/Icon/DeleteGrayIcon";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";

import { ActionWrapper, EditColumnAction, EditColumnWrapper, StyledDataTypeRender } from "../CommonStyles";

import { Error } from "./Error";
import { TableColumn } from "../../../rule-engine-core/Rule/Table/Common/TableColumn";
import { IRuleTableDefinition } from "../../../rule-engine-core/Rule/Table/Common/IRuleTableDefinition";
import { TestContext } from "../../../CommonUI/Testing/TestContext";
import { InlineTextEdit } from "../../../CommonUI/InlineEditor/InlineTextEdit";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

interface IResultColumnRender {
    ruleDefinition: IRuleTableDefinition;
    resultColumn: TableColumn;
}

export const XResultColumn = (props: IResultColumnRender) => {
    const { resultColumn, ruleDefinition } = props;

    const testContext = React.useContext(TestContext);

    const onRemove = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();

        ruleDefinition.removeResultColumn(resultColumn._id);
        StateManager.propertyChanged(ruleDefinition, "resultColumns");
    };

    return (
        <RuleTableHeaderDiv>
            <ObserveState
                listenTo={resultColumn}
                properties={["name", "dataType"]}
                control={() => {
                    let validationIssues = ruleDefinition.getResultColumnValidationIssues(resultColumn);
                    return (
                        <RuleTableHeaderVariable>
                            <InlineTextEdit
                                small
                                onEdit={(newValue) => {
                                    ruleDefinition.getResultColumnType(resultColumn)!.name = newValue;
                                    resultColumn.name = newValue;
                                    //   ruleDefinition.setResultColumnType(resultColumn.)
                                }}
                                text={resultColumn.name ?? "Variable"}
                            ></InlineTextEdit>

                            <Error issues={validationIssues} />

                            <EditColumnWrapper className="edit-wrapper">
                                {ruleDefinition.canChangeOutputs && ruleDefinition.resultColumns.length > 1 ? (
                                    <EditColumnAction onClick={onRemove}>
                                        <DeleteGrayIcon />
                                    </EditColumnAction>
                                ) : null}
                            </EditColumnWrapper>

                            <ActionWrapper>
                                {testContext ? (
                                    <>{resultColumn.dataType}</>
                                ) : (
                                    <StyledDataTypeRender>
                                        <DataTypePicker
                                            variant={"minimal"}
                                            dataDef={
                                                ruleDefinition.getResultColumnType(resultColumn) ||
                                                DataUtilities.createDataByType(
                                                    resultColumn.dataType!,
                                                    resultColumn.name,
                                                )
                                            }
                                            updateCallback={(type: IDataDefinition) => {
                                                ruleDefinition.setResultColumnType(resultColumn, type);
                                                StateManager.propertyChanged(resultColumn, "dataType");
                                            }}
                                            readonly={!ruleDefinition.canChangeOutputs}
                                        />
                                    </StyledDataTypeRender>
                                )}
                            </ActionWrapper>
                        </RuleTableHeaderVariable>
                    );
                }}
            />
        </RuleTableHeaderDiv>
    );
};

const RuleTableHeaderDiv = styled.div`
    display: flex;
    flex-direction: row;
`;

const RuleTableHeaderVariable = styled.div`
    position: relative;

    min-width: 120px;
    min-height: 44px;

    width: 100%;
    height: 100%;

    background: ${UIStyleConstants.WHITE_COLOR};
    border: 1px solid ${UIStyleConstants.BLUE_COLOR};
    box-sizing: border-box;
    border-radius: 2px;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0px;
    text-align: left;
    padding: 29px 16px 13px;

    cursor: pointer;

    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

    .edit-button,
    .edit-wrapper {
        opacity: 0;
    }

    &:hover {
        .edit-button,
        .edit-wrapper {
            opacity: 1;
        }
    }
`;
